import {
  createMessageSuccess,
  createMessageError,
  createMessagePending,
} from "../actions/messages";

import { MessageService } from "../../lib/qc-api-client";

export function createMessage(data) {
  return (dispatch) => {
    dispatch(createMessagePending());
    MessageService.createMessage(data)
      .then((response) => {
        dispatch(
          createMessageSuccess({
            products: response.data,
          })
        );
      })
      .catch((error) => {
        console.error(error);
        dispatch(createMessageError(error));
      });
  };
}
